<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="page-title">
                    <h5>{{ 'sales.title' | translate }}</h5>
                </div>

                <div *ngIf="loading" class="text-center py-5">
                    {{ 'common.loading' | translate }} ...
                </div>

                <div *ngIf="error && !loading" class="alert alert-danger">
                    {{ 'sales.load_error' | translate }}
                </div>

                <div *ngIf="!loading && !error && sales.length === 0" class="empty-state">
                    <p class="text-muted">{{ 'sales.no_sales' | translate }}</p>
                </div>

                <div *ngIf="!loading && !error && sales.length > 0" class="card sales-card">
                    <div class="card-header">
                        <h5 class="mb-0">{{ 'sales.title' | translate }}</h5>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>{{ 'sales.product' | translate }}</th>
                                        <th>{{ 'sales.qty' | translate }}</th>
                                        <th>{{ 'sales.price' | translate }}</th>
                                        <th>{{ 'sales.customer' | translate }}</th>
                                        <th>{{ 'sales.date' | translate }}</th>
                                        <th>{{ 'sales.status' | translate }}</th>
                                        <th>{{ 'sales.actions' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let sale of sales">
                                        <td>{{ getProductName(sale) }}</td>
                                        <td>{{ sale.qty }}</td>
                                        <td>{{ sale.price | number }}</td>
                                        <td>{{ getCustomerName(sale) }}</td>
                                        <td>{{ formatDate(sale.createdAt) }}</td>
                                        <td>
                                            <span [class]="getStatusClass(sale.status)">
                                                {{ getStatusLabel(sale.status) | translate }}
                                            </span>
                                        </td>
                                        <td>
                                            <button class="btn-action" (click)="viewSale(sale)" title="{{ 'sales.view_details' | translate }}">
                                                <i class="fa fa-eye fa-view-link"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex justify-content-center mt-3" *ngIf="totalItems > itemsPerPage">
                            <pagination-controls
                                (pageChange)="onPageChange($event)"
                                [maxSize]="5"
                                previousLabel=""
                                nextLabel="">
                            </pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-sidebar [currentUser]="user"></app-sidebar>
            </div>
        </div>
    </div>
</div>
